import type { ButtonSizeValues } from './button-types';

export const ButtonSizes: Record<string, ButtonSizeValues> = {
  small: 'small',
  normal: 'normal',
  large: 'large',
};
